module.exports = __webpack_public_path__ + "img/section-obras.eef366a2.jpeg";